var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirtcubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#5C5454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.9062C4 7.98746 7.98746 4 12.9062 4H23.5312V44H12.8615C7.96745 44 4 40.0326 4 35.1385V12.9062Z",
    fill: "#00ADEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.5625,
    height: 7.8125,
    rx: 3.90625,
    transform: "matrix(1 0 0 -1 27.4375 11.8125)",
    fill: "#FFC704"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0938 44H27.4375V15.7188H44V25.2891H36.75C35.9216 25.2891 35.25 25.9606 35.25 26.7891V32.9297C35.25 33.7581 35.9216 34.4297 36.75 34.4297H44V35.0938C44 40.0125 40.0125 44 35.0938 44Z",
    fill: "#FF0048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirtcubeLogo);
export default __webpack_public_path__ + "static/media/Dirtcube_Logo.7f62c2991cc30bd06df92f5cabd3393f.svg";
export { ForwardRef as ReactComponent };